

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Grid,
//   Typography,
//   Link,
//   useMediaQuery,
//   Pagination,
//   IconButton
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { addProperty } from '../../../Commonlibs/userSlice';// this is the action to add property IDs to Redux store
// import Loader from '../../../Loader/Loader';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';// these are the arrow imports

// const ResidentialView = () => {
//   const theme = useTheme();
//   const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const navigate = useNavigate();
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const dispatch = useDispatch();

//   // Get user data from Redux store for recording views
//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalProperties, setTotalProperties] = useState(0);

//   // Image slider state - tracks current image index for each property
//   const [currentImageIndex, setCurrentImageIndex] = useState({});

//   useEffect(() => {
//     const fetchResidentialProperties = async () => {
//       try {
//         setLoading(true);

//         // API call with pagination - GET request
//         const response = await fetch(
//           `https://propertydealstalk.com/api/property/getPropertiesByType?property_type=residential&page=${page}&limit=10`,
//           {
//             method: 'GET',
//             headers: {
//               'Content-Type': 'application/json',
//             }
//           }
//         );

//         if (!response.ok) {
//           throw new Error('Failed to fetch residential properties');
//         }

//         const data = await response.json();
        
//         if (data.success && data.properties) {
//           setProperties(data.properties);
          
//           // Initialize image index for each property
//           const initialImageIndex = {};
//           data.properties.forEach(property => {
//             initialImageIndex[property.id] = 0;
//           });
//           setCurrentImageIndex(initialImageIndex);
          
//           // Set pagination data from API response
//           if (data.pagination) {
//             setTotalPages(data.pagination.totalPages);
//             setTotalProperties(data.pagination.total);
//           }
          
//           // Store each property ID in Redux
//           data.properties.forEach(property => {
//             dispatch(addProperty(property.id));
//           });
//         } else {
//           throw new Error(data.message || 'Failed to get property data');
//         }
//       } catch (err) {
//         console.error('Error fetching residential properties:', err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchResidentialProperties();
//   }, [dispatch, page]);

//   // Function to record property view
//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       console.log('User not logged in, skipping view recording');
//       return;
//     }

//     try {
//       const userId = userData.id;
      
//       if (!userId) {
//         console.error('User ID not found in user data');
//         return;
//       }

//       console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();
      
//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully:', data.result);
//       } else {
//         console.error('Failed to record property view:', data.message);
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   // Function to handle page change
//   const handlePageChange = (event, value) => {
//     setPage(value);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // ✅ Function to check if image has valid data
//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEEoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=";
//   };

//   // ✅ Function to check if a value is valid (not null, undefined, 'N/A', or empty)
//   const isValidValue = (value) => {
//     return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
//   };

//   // ✅ Function to format price with Indian numbering system (lakhs format)
//   const formatPrice = (price) => {
//     if (!price || price === 0 || price === '0') return '';

//     const priceStr = price.toString();
//     const lastThree = priceStr.substring(priceStr.length - 3);
//     const otherNumbers = priceStr.substring(0, priceStr.length - 3);

//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }

//     return lastThree;
//   };

//   // ✅ FIXED: Function to get display price - matches TalkView.jsx logic
//   const getDisplayPrice = (property) => {
//     // Check if this is a rental property (case-insensitive comparison)
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       // For rental properties, prioritize monthly_rent
//       if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
//         return property.monthly_rent;
//       }
//     }

//     // For sale properties or if monthly_rent is not available, use asking_price
//     if (isValidValue(property.asking_price) && property.asking_price !== 0) {
//       return property.asking_price;
//     }

//     return null; // Return null if no price is available
//   };

//   // ✅ UPDATED: Function to get only valid property amenities
//   const getPropertyAmenities = (property) => {
//     const amenities = [];

//     // Check property size
//     if (isValidValue(property.property_size)) {
//       const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       amenities.push(`${property.property_size} ${sizeUnit}`);
//     }

//     // Check BHK
//     if (isValidValue(property.bhk)) {
//       amenities.push(`${property.bhk} BHK`);
//     }

//     // Check Floor - only add if both select_floor and total_floors are valid
//     if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
//       amenities.push(`${property.select_floor}/${property.total_floors} Floor`);
//     }

//     return amenities;
//   };

//   // ✅ NEW: Function to get all images for a property (assuming property might have multiple images)
//   const getPropertyImages = (property) => {
//     const images = [];
//     if (hasValidImage(property.image)) {
//       images.push(property.image);
//     }
//     // If you have multiple image fields like image1, image2, etc., add them here
//     // For now, we'll assume only one image field exists
//     return images;
//   };

//   // ✅ Function to format time ago (like "2w ago")
//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
    
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
    
//     const intervals = {
//       y: 31536000,
//       mo: 2592000,
//       w: 604800,
//       d: 86400,
//       h: 3600,
//       m: 60,
//       s: 1
//     };
    
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) {
//         return `${interval}${key} ago`;
//       }
//     }
    
//     return 'just now';
//   };

//   // ✅ Handle image navigation
//   const handlePrevImage = (e, propertyId, totalImages) => {
//     e.stopPropagation(); // Prevent card click
//     setCurrentImageIndex(prev => ({
//       ...prev,
//       [propertyId]: prev[propertyId] > 0 ? prev[propertyId] - 1 : totalImages - 1
//     }));
//   };

//   const handleNextImage = (e, propertyId, totalImages) => {
//     e.stopPropagation(); // Prevent card click
//     setCurrentImageIndex(prev => ({
//       ...prev,
//       [propertyId]: prev[propertyId] < totalImages - 1 ? prev[propertyId] + 1 : 0
//     }));
//   };

//   // Handle click on property card
//   const handlePropertyClick = (propertyId) => {
//     // Record the property view
//     recordPropertyView(propertyId);
//     // Navigate to property details page
//     navigate(`/view/${propertyId}`);
//   };

//   return (
//     <Box
//       sx={{
//         px: '40px',
//         pb: '40px',
//         fontFamily: 'Outfit',
//         bgcolor: '#F9FAFB',
//       }}
//     >
//       {/* ✅ Custom Loading Effect */}
//       {loading && <Loader />}

//       {/* Header */}
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'flex-end',
//           py: '30px',
//         }}
//       >
//         <Box>
//           <Typography sx={{ fontSize: 24, fontWeight: 600, m: 0 }}>
//             Residential Properties
//           </Typography>
//           <Typography sx={{ fontSize: 14, color: '#626262', mt: '4px', fontWeight: 400 }}>
//             Leading Project in high demand
//           </Typography>
//         </Box>
//         <Link
//           href="/"
//           underline="none"
//           sx={{ fontWeight: 500, color: '#626262' }}
//         >
//           Back to Home
//         </Link>
//       </Box>

//       {/* Property Grid */}
//       {error ? (
//         <Box sx={{ textAlign: 'center', py: 4, color: 'error.main' }}>
//           <Typography>{error}</Typography>
//         </Box>
//       ) : properties.length === 0 && !loading ? (
//         <Box sx={{ textAlign: 'center', py: 4 }}>
//           <Typography>No residential properties found</Typography>
//         </Box>
//       ) : !loading ? (
//         <>
//           <Grid
//             container
//             spacing={2}
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: isMobile
//                 ? '1fr'
//                 : isTablet
//                 ? 'repeat(2, 1fr)'
//                 : 'repeat(4, 1fr)',
//               gap: '20px',
//             }}
//           >
//             {properties.map((property, i) => {
//               const images = getPropertyImages(property);
//               const hasImages = images.length > 0;
//               const currentIndex = currentImageIndex[property.id] || 0;
//               const amenities = getPropertyAmenities(property);
//               const displayPrice = getDisplayPrice(property);
//               const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
//               const timeAgo = getTimeAgo(property.createdAt || property.updatedAt);

//               return (
//                 <Box
//                   key={property.id}
//                   onClick={() => handlePropertyClick(property.id)}
//                   sx={{
//                     display: 'flex',
//                     flexDirection: isMobile ? 'column' : 'row',
//                     height: isMobile ? 'auto' : '200px',
//                     bgcolor: '#fff',
//                     border: '1px solid #D1D5DB',
//                     borderRadius: '12px',
//                     overflow: 'hidden',
//                     boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
//                     transition: 'transform 0.2s',
//                     cursor: 'pointer',
//                     '&:hover': {
//                       transform: 'translateY(-4px)',
//                     },
//                   }}
//                 >
//                   {/* ✅ Image Slider Section with Time Badge */}
//                   <Box
//                     sx={{
//                       width: isMobile ? '100%' : '50%',
//                       height: isMobile ? '200px' : '100%',
//                       position: 'relative',
//                       overflow: 'hidden',
//                     }}
//                   >
//                     {hasImages ? (
//                       <>
//                         {/* Image */}
//                         <Box
//                           component="img"
//                           src={`data:image/png;base64,${images[currentIndex]}`}
//                           alt={property.property_name}
//                           sx={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover',
//                           }}
//                         />

//                         {/* ✅ Image Navigation Arrows (only show if multiple images) */}
//                         {images.length > 1 && (
//                           <>
//                             {/* Left Arrow */}
//                             <IconButton
//                               onClick={(e) => handlePrevImage(e, property.id, images.length)}
//                               sx={{
//                                 position: 'absolute',
//                                 left: '8px',
//                                 top: '50%',
//                                 transform: 'translateY(-50%)',
//                                 bgcolor: 'rgba(255, 255, 255, 0.8)',
//                                 width: '32px',
//                                 height: '32px',
//                                 '&:hover': {
//                                   bgcolor: 'rgba(255, 255, 255, 0.95)',
//                                 },
//                                 zIndex: 2,
//                               }}
//                             >
//                               <ArrowBackIosNewIcon sx={{ fontSize: 16, color: '#000' }} />
//                             </IconButton>

//                             {/* Right Arrow */}
//                             <IconButton
//                               onClick={(e) => handleNextImage(e, property.id, images.length)}
//                               sx={{
//                                 position: 'absolute',
//                                 right: '8px',
//                                 top: '50%',
//                                 transform: 'translateY(-50%)',
//                                 bgcolor: 'rgba(255, 255, 255, 0.8)',
//                                 width: '32px',
//                                 height: '32px',
//                                 '&:hover': {
//                                   bgcolor: 'rgba(255, 255, 255, 0.95)',
//                                 },
//                                 zIndex: 2,
//                               }}
//                             >
//                               <ArrowForwardIosIcon sx={{ fontSize: 16, color: '#000' }} />
//                             </IconButton>

//                             {/* ✅ Image Dots Indicator */}
//                             <Box
//                               sx={{
//                                 position: 'absolute',
//                                 bottom: '8px',
//                                 left: '50%',
//                                 transform: 'translateX(-50%)',
//                                 display: 'flex',
//                                 gap: '6px',
//                                 zIndex: 2,
//                               }}
//                             >
//                               {images.map((_, idx) => (
//                                 <Box
//                                   key={idx}
//                                   sx={{
//                                     width: '6px',
//                                     height: '6px',
//                                     borderRadius: '50%',
//                                     bgcolor: idx === currentIndex ? '#fff' : 'rgba(255, 255, 255, 0.5)',
//                                     transition: 'all 0.3s',
//                                   }}
//                                 />
//                               ))}
//                             </Box>
//                           </>
//                         )}
//                       </>
//                     ) : (
//                       <Box
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           border: '1px dashed #ccc'
//                         }}
//                       >
//                         <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                           No images uploaded
//                         </Typography>
//                       </Box>
//                     )}

//                     {/* ✅ Time Ago Badge - Shows for ALL properties */}
//                     {timeAgo && (
//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           bottom: '8px',
//                           right: '8px',
//                           bgcolor: 'rgba(0, 0, 0, 0.7)',
//                           color: '#fff',
//                           px: '8px',
//                           py: '4px',
//                           borderRadius: '4px',
//                           fontSize: '11px',
//                           fontWeight: 500,
//                           zIndex: 3,
//                           fontFamily: 'Outfit, sans-serif',
//                         }}
//                       >
//                         {timeAgo}
//                       </Box>
//                     )}
//                   </Box>

//                   {/* Info */}
//                   <Box
//                     sx={{
//                       width: isMobile ? '100%' : '50%',
//                       p: 2,
//                       display: 'flex',
//                       flexDirection: 'column',
//                       justifyContent: 'space-between',
//                       gap: '6px',
//                       boxSizing: 'border-box',
//                     }}
//                   >
//                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: '#000' }}>
//                       {property.property_name}
//                     </Typography>

//                     {property.seller && property.seller.full_name ? (
//                       <Typography sx={{ fontSize: 12, color: '#626262', fontWeight: 400 }}>
//                         by {property.seller.full_name}
//                       </Typography>
//                     ) : (
//                       <Typography
//                         sx={{
//                           visibility: 'hidden',
//                           fontSize: 14,
//                           height: '18px',
//                         }}
//                       >
//                       </Typography>
//                     )}

//                     <Typography
//                       sx={{
//                         fontSize: 12,
//                         color: '#626262',
//                         fontWeight: 400,
//                         mt: '1px',
//                         mb: '0px',
//                       }}
//                     >
//                       {property.area_name}, {property.location}
//                     </Typography>

//                     {/* ✅ UPDATED: Icons - Only show valid amenities */}
//                     {amenities.length > 0 && (
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           flexDirection: 'column',
//                           gap: '1px',
//                           mt: '1px',
//                         }}
//                       >
//                         {amenities.map((amenity, index) => (
//                           <Box
//                             key={index}
//                             component="span"
//                             sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}
//                           >
//                             <Typography sx={{ fontSize: 12, color: '#626262' }}>
//                               {amenity}
//                             </Typography>
//                           </Box>
//                         ))}
//                       </Box>
//                     )}

//                     {/* ✅ FIXED: Price with proper spacing and conditional rendering */}
//                     <Typography
//                       sx={{
//                         fontWeight: 600,
//                         fontStyle: 'SemiBold',
//                         color: '#2563EB',
//                         fontSize: 16,
//                         mt: '0.4px',
//                         mb: '18px',
//                       }}
//                     >
//                       {displayPrice ? (
//                         <>
//                           ₹ {formatPrice(displayPrice)}
//                           {isRental && '/month'}
//                         </>
//                       ) : (
//                         'Price on Request'
//                       )}
//                     </Typography>
//                   </Box>
//                 </Box>
//               );
//             })}
//           </Grid>

//           {/* ✅ Pagination component - Moved to RIGHT CORNER */}
//           {totalPages > 1 && (
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
//               <Pagination
//                 count={totalPages}
//                 page={page}
//                 onChange={handlePageChange}
//                 color="primary"
//                 size={isMobile ? "small" : "medium"}
//                 showFirstButton
//                 showLastButton
//                 sx={{
//                   '& .MuiPaginationItem-root': {
//                     color: '#333',
//                   },
//                   '& .Mui-selected': {
//                     backgroundColor: '#2563EB !important',
//                     color: 'white',
//                   }
//                 }}
//               />
//             </Box>
//           )}
//         </>
//       ) : null}
//     </Box>
//   );
// };

// export default ResidentialView;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Link,
  useMediaQuery,
  Pagination,
  IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addProperty } from '../../../Commonlibs/userSlice';
import Loader from '../../../Loader/Loader';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ResidentialView = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalProperties, setTotalProperties] = useState(0);

  const [currentImageIndex, setCurrentImageIndex] = useState({});

  // Function to get user-friendly error message
  const getUserFriendlyErrorMessage = (error) => {
    const errorString = error.toString().toLowerCase();
    
    if (errorString.includes('fetch') || 
        errorString.includes('network') || 
        errorString.includes('failed to fetch') ||
        errorString.includes('networkerror') ||
        errorString.includes('connection')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('timeout')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('500') || errorString.includes('server error')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('404') || errorString.includes('not found')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    return 'Unable to load the properties. Please check your internet connection and try again.';
  };

  useEffect(() => {
    const fetchResidentialProperties = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `https://propertydealstalk.com/api/property/getPropertiesByType?property_type=residential&page=${page}&limit=10`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        if (data.success && data.properties) {
          setProperties(data.properties);
          
          const initialImageIndex = {};
          data.properties.forEach(property => {
            initialImageIndex[property.id] = 0;
          });
          setCurrentImageIndex(initialImageIndex);
          
          if (data.pagination) {
            setTotalPages(data.pagination.totalPages);
            setTotalProperties(data.pagination.total);
          }
          
          data.properties.forEach(property => {
            dispatch(addProperty(property.id));
          });
        } else {
          throw new Error('Unable to load properties');
        }
      } catch (err) {
        console.error('Error fetching residential properties:', err);
        const friendlyMessage = getUserFriendlyErrorMessage(err);
        setError(friendlyMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchResidentialProperties();
  }, [dispatch, page]);

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      console.log('User not logged in, skipping view recording');
      return;
    }

    try {
      const userId = userData.id;
      
      if (!userId) {
        console.error('User ID not found in user data');
        return;
      }

      console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();
      
      if (data.statusCode === 200) {
        console.log('Property view recorded successfully:', data.result);
      } else {
        console.error('Failed to record property view:', data.message);
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const hasValidImage = (base64) => {
    return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEEoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=";
  };

  const isValidValue = (value) => {
    return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
  };

  const formatPrice = (price) => {
    if (!price || price === 0 || price === '0') return '';

    const priceStr = price.toString();
    const lastThree = priceStr.substring(priceStr.length - 3);
    const otherNumbers = priceStr.substring(0, priceStr.length - 3);

    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }

    return lastThree;
  };

  const getDisplayPrice = (property) => {
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
        return property.monthly_rent;
      }
    }

    if (isValidValue(property.asking_price) && property.asking_price !== 0) {
      return property.asking_price;
    }

    return null;
  };

  const getPropertyAmenities = (property) => {
    const amenities = [];

    if (isValidValue(property.property_size)) {
      const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      amenities.push(`${property.property_size} ${sizeUnit}`);
    }

    if (isValidValue(property.bhk)) {
      amenities.push(`${property.bhk} BHK`);
    }

    if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
      amenities.push(`${property.select_floor}/${property.total_floors} Floor`);
    }

    return amenities;
  };

  const getPropertyImages = (property) => {
    const images = [];
    if (hasValidImage(property.image)) {
      images.push(property.image);
    }
    return images;
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  const handlePrevImage = (e, propertyId, totalImages) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => ({
      ...prev,
      [propertyId]: prev[propertyId] > 0 ? prev[propertyId] - 1 : totalImages - 1
    }));
  };

  const handleNextImage = (e, propertyId, totalImages) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => ({
      ...prev,
      [propertyId]: prev[propertyId] < totalImages - 1 ? prev[propertyId] + 1 : 0
    }));
  };

  const handlePropertyClick = (propertyId) => {
    recordPropertyView(propertyId);
    navigate(`/view/${propertyId}`);
  };

  return (
    <Box
      sx={{
        px: '40px',
        pb: '40px',
        fontFamily: 'Outfit',
        bgcolor: '#F9FAFB',
      }}
    >
      {loading && <Loader />}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          py: '30px',
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 24, fontWeight: 600, m: 0 }}>
            Residential Properties
          </Typography>
          <Typography sx={{ fontSize: 14, color: '#626262', mt: '4px', fontWeight: 400 }}>
            Leading Project in high demand
          </Typography>
        </Box>
        <Link
          href="/"
          underline="none"
          sx={{ fontWeight: 500, color: '#626262' }}
        >
          Back to Home
        </Link>
      </Box>

      {error ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center',
            minHeight: '300px'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500,
              maxWidth: '600px'
            }}
          >
            {error}
          </Typography>
        </Box>
      ) : properties.length === 0 && !loading ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center',
            minHeight: '300px'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500
            }}
          >
            No residential properties found
          </Typography>
        </Box>
      ) : !loading ? (
        <>
          <Grid
            container
            spacing={2}
            sx={{
              display: 'grid',
              gridTemplateColumns: isMobile
                ? '1fr'
                : isTablet
                ? 'repeat(2, 1fr)'
                : 'repeat(4, 1fr)',
              gap: '20px',
            }}
          >
            {properties.map((property, i) => {
              const images = getPropertyImages(property);
              const hasImages = images.length > 0;
              const currentIndex = currentImageIndex[property.id] || 0;
              const amenities = getPropertyAmenities(property);
              const displayPrice = getDisplayPrice(property);
              const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
              const timeAgo = getTimeAgo(property.createdAt || property.updatedAt);

              return (
                <Box
                  key={property.id}
                  onClick={() => handlePropertyClick(property.id)}
                  sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    height: isMobile ? 'auto' : '200px',
                    bgcolor: '#fff',
                    border: '1px solid #D1D5DB',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                    transition: 'transform 0.2s',
                    cursor: 'pointer',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: isMobile ? '100%' : '50%',
                      height: isMobile ? '200px' : '100%',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    {hasImages ? (
                      <>
                        <Box
                          component="img"
                          src={`data:image/png;base64,${images[currentIndex]}`}
                          alt={property.property_name}
                          sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />

                        {images.length > 1 && (
                          <>
                            <IconButton
                              onClick={(e) => handlePrevImage(e, property.id, images.length)}
                              sx={{
                                position: 'absolute',
                                left: '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                bgcolor: 'rgba(255, 255, 255, 0.8)',
                                width: '32px',
                                height: '32px',
                                '&:hover': {
                                  bgcolor: 'rgba(255, 255, 255, 0.95)',
                                },
                                zIndex: 2,
                              }}
                            >
                              <ArrowBackIosNewIcon sx={{ fontSize: 16, color: '#000' }} />
                            </IconButton>

                            <IconButton
                              onClick={(e) => handleNextImage(e, property.id, images.length)}
                              sx={{
                                position: 'absolute',
                                right: '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                bgcolor: 'rgba(255, 255, 255, 0.8)',
                                width: '32px',
                                height: '32px',
                                '&:hover': {
                                  bgcolor: 'rgba(255, 255, 255, 0.95)',
                                },
                                zIndex: 2,
                              }}
                            >
                              <ArrowForwardIosIcon sx={{ fontSize: 16, color: '#000' }} />
                            </IconButton>

                            <Box
                              sx={{
                                position: 'absolute',
                                bottom: '8px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                gap: '6px',
                                zIndex: 2,
                              }}
                            >
                              {images.map((_, idx) => (
                                <Box
                                  key={idx}
                                  sx={{
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    bgcolor: idx === currentIndex ? '#fff' : 'rgba(255, 255, 255, 0.5)',
                                    transition: 'all 0.3s',
                                  }}
                                />
                              ))}
                            </Box>
                          </>
                        )}
                      </>
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc'
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}

                    {timeAgo && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: '8px',
                          right: '8px',
                          bgcolor: 'rgba(0, 0, 0, 0.7)',
                          color: '#fff',
                          px: '8px',
                          py: '4px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          fontWeight: 500,
                          zIndex: 3,
                          fontFamily: 'Outfit, sans-serif',
                        }}
                      >
                        {timeAgo}
                      </Box>
                    )}
                  </Box>

                  <Box
                    sx={{
                      width: isMobile ? '100%' : '50%',
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      gap: '6px',
                      boxSizing: 'border-box',
                    }}
                  >
                    <Typography sx={{ fontSize: 15, fontWeight: 500, color: '#000' }}>
                      {property.property_name}
                    </Typography>

                    {property.seller && property.seller.full_name ? (
                      <Typography sx={{ fontSize: 12, color: '#626262', fontWeight: 400 }}>
                        by {property.seller.full_name}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          visibility: 'hidden',
                          fontSize: 14,
                          height: '18px',
                        }}
                      >
                      </Typography>
                    )}

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: '#626262',
                        fontWeight: 400,
                        mt: '1px',
                        mb: '0px',
                      }}
                    >
                      {property.area_name}, {property.location}
                    </Typography>

                    {amenities.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '1px',
                          mt: '1px',
                        }}
                      >
                        {amenities.map((amenity, index) => (
                          <Box
                            key={index}
                            component="span"
                            sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                          >
                            <Typography sx={{ fontSize: 12, color: '#626262' }}>
                              {amenity}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}

                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontStyle: 'SemiBold',
                        color: '#2563EB',
                        fontSize: 16,
                        mt: '0.4px',
                        mb: '18px',
                      }}
                    >
                      {displayPrice ? (
                        <>
                          ₹ {formatPrice(displayPrice)}
                          {isRental && '/month'}
                        </>
                      ) : (
                        'Price on Request'
                      )}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Grid>

          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size={isMobile ? "small" : "medium"}
                showFirstButton
                showLastButton
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#333',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#2563EB !important',
                    color: 'white',
                  }
                }}
              />
            </Box>
          )}
        </>
      ) : null}
    </Box>
  );
};

export default ResidentialView;
